<style>
.setpsd {
  box-sizing: border-box;
  padding: 0 80px;
  background: #fff;
  overflow: hidden;
  margin-top: 25px;
  padding-bottom: 300px;
  width: 1200px;
  height: 730px;
}

.set-form {
  margin-top: 100px;
}

.set-input {
  width: 360px !important;
}

.setpsd .el-form-item {
  margin-bottom: 25px;
}

.setpsd .el-input__inner {
  height: 45px;
  line-height: 45px;
}

.set-submit {
  margin-top: 45px;
  margin-left: 250px;
}

.update-psd {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
}

.setpsd .el-form-item__label,
.setpsd .el-form-item__error {
  margin-left: 250px;
}

.set-submit .el-button--primary {
  font-size: 16px;
  width: 120px;
  height: 40px;
  border-radius: 20px;
}

.set-submit .el-button + .el-button {
  border-radius: 20px;
  width: 100px;
}
.el-button.redBtn {
  background: #f83b56;
  color: #fff;
}

.el-button.darkBtn {
  background: #3b404f;
  color: #fff;
}
</style>
<template>
  <div>
    <Header/>
    <div class="content setpsd">
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px"
               class="demo-ruleForm set-form">
        <div class="update-psd">修改密码</div>
        <el-form-item label="原密码：" prop="oldPass">
          <el-input type="password" autocomplete="off" v-model="ruleForm2.oldPass" auto-complete="off" class="set-input"
                    placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="pass">
          <el-input type="password" autocomplete="off" v-model="ruleForm2.pass" auto-complete="off" class="set-input"
                    placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="请确认：" prop="checkPass">
          <el-input type="password" autocomplete="off" v-model="ruleForm2.checkPass" auto-complete="off" class="set-input" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
        <el-form-item class="set-submit">
          <el-button class="redBtn" @click="submitForm('ruleForm2')">确认修改</el-button>
          <el-button class="darkBtn" @click="resetForm('ruleForm2')" plain>取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import { updateStaffPsd } from "@/api";
import CryptoJS from 'crypto-js'

export default {
  components: {
    Header,
    Footer
  },
  data() {
    var checkoldPass = (rule, value, callback) => {
      var reg = /^[A-Za-z0-9]{1,30}$/;
      if (value === "") {
        callback(new Error("请输入原密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为字母和数字，请设置正确格式的密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度最小6位"));
      } else if (value.length > 16) {
        callback(new Error("密码长度最大16位"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var reg = /^[A-Za-z0-9]{1,30}$/;
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为字母和数字，请设置正确格式的密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度最小6位"));
      } else if (value.length > 16) {
        callback(new Error("密码长度最大16位"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var reg = /^[A-Za-z0-9]{1,30}$/;
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else if (!reg.test(value)) {
        callback(new Error("密码格式为字母和数字，请设置正确格式的密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度最小6位"));
      } else if (value.length > 16) {
        callback(new Error("密码长度最大16位"));
      } else {
        callback();
      }
    };
    return {
      ruleForm2: {
        oldPass: "",
        pass: "",
        checkPass: ""
      },
      rules2: {
        oldPass: [
          {required: true, message: "请输入原密码", trigger: "change"},
          { validator: checkoldPass, trigger: "blur" }
        ],
        pass: [
          {required: true, message: "请输入新密码", trigger: "change"},
          { validator: validatePass, trigger: "blur" }
        ],
        checkPass: [
          {required: true, message: "请再次输入密码", trigger: "change"},
          { validator: validatePass2, trigger: "blur" }
        ]
      }
    };
  },
  activated() {
    this.$refs.ruleForm2.resetFields();
  },
  methods: {
    operaEntryDES(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
      var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let postData = {
            staffId: this.$store.state.userInfo.staffId,
            password: this.operaEntryDES(this.ruleForm2.pass),
            oldPassword: this.operaEntryDES(this.ruleForm2.oldPass)
          };

          const date = updateStaffPsd(postData);
          date
            .then(res => {
              this.$message({
                message: res.msg,
                type: res.code == 1 ? "success" : "error"
              });
              if (res.code == 1) {
                this.$refs[formName].resetFields();
              }
            })
            .catch(error => {
              this.$message({
                message: "网络连接失败，请稍后再试",
                type: "error"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/home/setpsd.vue